import React from "react";
import "./TabLineItem.css";

function TabLineItem() {
  return <div className="tab-line-item"></div>;
}

export default TabLineItem;
